/**
 * 匿名情况下接口的处理 
 * */

// 判断有无匿名
export function hasNoAuth(shortUrl) {
    var regOld = /\_$/
    var regNew = /[a-zA-Z0-9]{6}ano$/
    return regOld.test(shortUrl) || regNew.test(shortUrl)
}

export function getNoAuthShortUrl(shortUrl){
    var regOld = /\_$/
    if (regOld.test(shortUrl)) {
        return shortUrl.replace("_", "") + "ano"
    }else{
        return shortUrl
    }
}

// 为静态文件去除匿名的后缀
export function cleanNoAuthSuffix(shortUrl){
    var regOld = /\_$/
    if (regOld.test(shortUrl)) {
        return shortUrl.slice(0, -1)
    }else{
        return shortUrl.slice(0, -3)
    }
}


// WEBPACK FOOTER //
// ./src/lib/noauth.js